import { Component, EventEmitter, AfterViewInit, OnInit, Output,ElementRef, ViewChildren } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';

@Component({
  selector: 'user-help',
  template: require('./user-help.component.html'),
})
export class HelpUserComponent implements AfterViewInit, OnInit {
  modalActions = new EventEmitter<string | MaterializeAction>();
  constructor(){
    
  }
 
  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    
  }

  openHelpUserModal(): void {
    $('#modal-user-help').modal('open');
  }


  closeHelp(): void {
    $('#modal-user-help').modal('close');
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user-help.component.ts